import React from "react";

const Multiline = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/2000/xlink"
    >
        <path
            className="u_fill"
            fill={fill}
            d="M34 10v4.57H2.021V10zM25.559 21.428V26H1.999v-4.57z"
        />
    </svg>
);

export default Multiline;


